/** Adds one passive listener for several event types and returns the function that removes it. */
export const listen = (
  target: EventTarget,
  types: string[],
  listener: EventListener
) => {
  types.forEach((type) =>
    target.addEventListener(type, listener, { passive: true })
  );
  return () =>
    types.forEach((type) => target.removeEventListener(type, listener));
};
